import { getPublicSettings } from '@/react/portainer/settings/settings.service';
import { FeatureFlag } from '@/react/portainer/feature-flags/useFeatureFlag';
const _paq = (window._paq = window._paq || []);

export async function initializeMatomo() {
  const settings = await getPublicSettings();
  if (settings.Features[FeatureFlag.DISABLE_EXTERNAL_REQUESTS]) {
    return;
  }

  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  var u = 'https://portainer-ce.matomo.cloud/';
  _paq.push(['setTrackerUrl', u + 'matomo.php']);
  _paq.push(['setSiteId', '2']);
  var d = document,
    g = d.createElement('script'),
    s = d.getElementsByTagName('script')[0];
  g.type = 'text/javascript';
  g.async = true;
  g.src = '//cdn.matomo.cloud/portainer-ce.matomo.cloud/matomo.js';
  s.parentNode.insertBefore(g, s);
}

// Don't initialize Matomo immediately
// It will be initialized in index.js after checking feature flags
